import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sidebarCollapse: false,
    appMiniWidth: false,
    userInfo: null,
    isLogin: false,
    china: null
  },
  mutations: {
    setSidebarCollapse(state, params) {
      state.sidebarCollapse = params;
    },
    setAppMiniWidth(state, params) {
      state.appMiniWidth = params;
    },
    setUserInfo(state, params) {
      state.userInfo = params;
    },
    setIsLogin(state, params) {
      state.isLogin = params;
    },
    setChina(state, params) {
      state.china = params;
    }
  },
  actions: {

  }
});